import { useFeatureFlags } from '@usap/core'
import getCookieRegex from '../helpers/getCookieRegex'

const useDynamicShippingEnabled = () => {
  const { f93 } = useFeatureFlags()
  if (f93 !== null && f93 !== undefined) {
    return f93 === 'b' || f93 === '1' || f93 === 'c' || f93 === 'on' || f93 === 'true'
  }
  return false
}

const useDynamicShippingCookie = () => {
  const { f93 } = useFeatureFlags()
  const f93CookieWindow = getCookieRegex('f93')

  if (f93CookieWindow) {
    return f93CookieWindow
  }

  if (f93) {
    return f93
  }

  return null
}

export { useDynamicShippingEnabled, useDynamicShippingCookie }
